import axios from "axios";
import axios2 from "@/axios";
import moment from "moment";

const state = {
  selectedTemplate: 0,
  templates: [],
};

const getters = {
  retrieveAllTemplates: (state) => {
    return state.templates;
  },

  retrieveCurrentTemplate: (state) => {
    let trolly = false;

    if (state.templates && state.templates.length > 0) {
      state.templates.forEach((template) => {
        if (template.id == state.selectedTemplate) {
          trolly = template;

          trolly.order_date_display = moment(trolly.order_date).format(
            "dddd, Do MMMM YYYY"
          );

          Object.keys(trolly.trolly_items).forEach(function(key) {
            switch (trolly.trolly_items[key].qty_type) {
              case "B":
                trolly.trolly_items[key].itemType = "Box";
                break;
              case "K":
                trolly.trolly_items[key].itemType = "Kilo";
                break;
              case "E":
                trolly.trolly_items[key].itemType = "Each";
                break;
            }
          });
        } else {
          console.log("  -- No Match");
        }
      });
    }

    return trolly;
  },
};

const actions = {
  async getTemplates({ commit }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      customerNo : this.getters.retrieveSelectedCustomer,
      template: 1,
    };
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2.post("trolly/get-trollys", params);

    if (response.data.success == true) {
      console.log("-- Trollies Response Data");
      console.log(response.data.trolly);
      commit("setTemplates", response.data.trolly);
      return response.data.success;
    } else {
      response.data.success;
    }
  },

  async setSelectedTemplate({ commit }, id) {
    commit("setSelectedTemplate", id);
  },

  async createNewTemplate({ commit }, orderInfo) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      template: 1,
      name: orderInfo.name,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios.post("create-new-trolly", params);

    if (response.data.success == true) {
      return response.data.success;
    } else {
      return false;
    }
  },
};

const mutations = {
  setTemplates: (state, value) => (state.templates = value),
  setSelectedTemplate: (state, value) => (state.selectedTemplate = value),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
